import React from 'react';
import { Link } from 'react-router-dom';
import { Col, Row } from 'reactstrap';
import activity from '../../assets/images/activity.svg';

const BreadCrumb = ({ title, pageTitle , pageTitleRoute,} : any) => {
    return (
        <React.Fragment>
                    <div className="page-title-box d-sm-flex align-items-center justify-content-between position-sticky  mobile-hide" style={{top:"70px", zIndex:"999"}}>
                        <h4 className="mb-sm-0">{title}</h4>

                        <div className="page-title-right">
                            <ol className="breadcrumb m-0">
                                <li className="breadcrumb-item fw-bold " ><Link to={pageTitleRoute}><span style={{color:"#808080"}}>{pageTitle}</span></Link></li>
                                <li className="breadcrumb-item active fw-bold text-secondary">{title}</li>
                            </ol>
                        </div>

                    </div>

                    <div id="page-topbar-mobile" className={" mobile-show"}>
                        <div className='d-flex align-items-center justify-content-between'>
                            <h3>{title}</h3>
                            <div className='actionSide'>
                                {/* <Link to='/key-metrics'><button><img src={activity} alt="" /></button></Link> */}
                                {/* <button><i className="ri-qr-scan-2-line"></i></button>
                                <button><i className="ri-notification-fill"></i></button> */}
                            </div>
                        </div>
                    </div>
        </React.Fragment>
    ); 
};

export default BreadCrumb;